<template>
  <div class="container-fluid">
    <el-pagination
      style="margin-top: 20px"
      :current-page="currentPage"
      background
      layout="pager"
      :total="totalCount"
      :page-size="50"
      @current-change="refresh"
    >
    </el-pagination>

    <div
      style="margin: 20px 5px"
      v-for="(item, index) in TableData"
      :key="index"
    >
      <div class="itemroot dohighlight">
        <div style="font-weight: bold; font-size: 15px">{{ item.model }}</div>
        <div style="color: gray">{{ $tt(getCatlogName(item)) }}</div>
        <img
          @click="imgViewClick(item)" 
          :src="item.picture"
          style="height: 80px; margin: 10px 0; cursor: pointer"
        />

        <div>{{translateStatus(item.status) }}</div>
        <div style="white-space: pre-wrap; margin: 10px">{{ item.remark }}</div>
        <div style="white-space: pre-wrap; margin: 10px" v-if="item.customerID">
           {{$t('customerID')}}:{{ item.customerID }}
        </div>
        <div style="white-space: pre-wrap; margin: 10px" v-if="item.bikeID">
           {{$t('bikeID')}}:{{ item.bikeID }}
        </div>
        <div style="white-space: pre-wrap; margin: 10px" v-if="item.price">
           {{$t('price')}}:{{ item.price }}
        </div>
        <div class="wrap"
          style="
            background-color: #eeeeee;
            padding: 10px 10px;
            margin: 10px -10px;
            border: 1px solid gainsboro;
          "
          v-html="item.description"
        />
      </div>
    </div>

 
  </div>

  <el-pagination
    style="margin: 20px 0 80px 0"
    :current-page="currentPage"
    background
    layout="pager"
    :total="totalCount"
    :page-size="50"
    @current-change="refresh"
  >
  </el-pagination>

  <el-dialog :fullscreen="true" v-model="showImgDialog">
    <img :src="showingImgSrc" />
  </el-dialog>
</template>

<script>
import {
  DeleteProducts,
  GetProductCatlog,
  GetProductPages,
  ChangePrice,
  SearchProductPages,
} from "../common/httphelper.js";
import Swal from "sweetalert2";
import router from "../router/index.js";
import "../common/role";
import getRole from "../common/role";
import Mark from "mark.js";
//#region
function highlight(text) {
  if (!text) return;
  var trs = document.querySelectorAll("div.dohighlight");
  trs.forEach((tr) =>
    tr.childNodes.forEach((td) => {
      var instance = new Mark(td);
      instance.mark(text);
    })
  );
}
//#endregion

export default {
  data() {  
    return {
      currentPage: 1,
      catlogid: "-1",
      TableData: [],
      totalCount: undefined,
      role: {},
      searchInput: "",
      catlogs: [],
      SearchAllText: "",
      SearchFormData:this.newFormData(),
      searchParam: this.newFormData()
    };
  },
  methods: {
    newFormData(){
      return  {
        model: "",
        catlog: "-1",
        status: "",
        more: {
          botelv: "全部",
          dengya: "全部",
          zhizaoshang: "全部",
          luosi: "全部",
          xiansu: "全部",
          chicun:"全部",
          xianjing:"全部",
          leibie:'全部',
          lianjieqi:'全部'
        },
      }
    },
    refresh(index = 1) {
      this.TableData = [];
      window.scrollTo(0, 0);
      SearchProductPages(this.searchParam.catlog, index, this.searchParam).then(
        (res) => {
          Swal.close();
          this.TableData = res.data.data;
          this.totalCount = res.data.count;
          this.currentPage = index;
        }
      );

      if (this.searchParam.catlog == -2) {
        setTimeout(() => {
          highlight(this.searchParam.model);
        }, 1000);
      }
    },
    splitStr(str) {
      if (!str) {
        return ["/"];
      } else {
        //console.log(str);
        return str.split("/");
      }
    },
    Delete(item) {
      Swal.fire({
        title: "确定删除吗?",
        text: "将创建删除操作的审批流程!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.isConfirmed) {
          DeleteProducts(item.id).then(async (res) => {
            if (res.data.data) {
              await Swal.fire({
                icon: "success",
                title: "已创建审批流程",
                showConfirmButton: false,
                timer: 3000,
              });
              this.refresh(this.currentPage);
            } else {
              await Swal.fire({
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              });
            }
          });
        }
      });
    },
    UpdateClick(item) {
      router.push({
        name: "AddProduct",
        query: {
          name: this.catlogname,
          item: JSON.stringify(item),
        },
      });
    },
    imgViewClick(item) {
      this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: this.TableData.indexOf(item),
        },
        images: this.TableData.map((item) => item.picture),
      });
    },
    restoreForm() {
      this.SearchFormData.model = "";
      this.SearchFormData.catlog = "-1";
      this.SearchFormData.status = "";
      this.SearchFormData.more = {
        botelv: "全部",
        dengya: "全部",
        zhizaoshang: "全部",
        luosi: "全部",
      };
      this.clickSearch();
    },
    clickSearch() {
      this.SearchFormData.model = this.SearchFormData.model.trim();
      this.searchParam = JSON.parse(JSON.stringify(this.SearchFormData));
      this.refresh(this.currentPage);
    },
    getCatlogName(item) {
      let result = this.catlogs.find((x) => x.id == item.catlogId);
      if (result) return result.name;
      else return "已删除类别";
    },

    async ChangePrice(item) {
      const { value: name } = await Swal.fire({
        title: "价格修改",
        type: "question",
        input: "text",
        inputValue: item.price,
        inputPlaceholder: "请输入产品价格",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
        allowOutsideClick: false,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      });

      if (!name) {
        return;
      }

      let price = Number(name);
      if (isNaN(price)) {
        await Swal.fire({
          icon: "error",
          title: "请填写正确的数字",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      ChangePrice({ id: item.id, price: price }).then(async (res) => {
        if (res.data.data) {
          await Swal.fire({
            icon: "success",
            title: "已提交价格修改审批",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          await Swal.fire({
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    translateStatus(status) {
      if (this.$i18n.locale == "English") {
        switch (status) {
          case "在销售":
            return "In sale";
          case "已停产(在维护)":
            return "Discontinued (in maintenance)";
          case "已停产(不维护)":
            return "Discontinued (no maintenance)";
          case "已停产(在维护)":
            return "Discontinued (in maintenance)";
          case "开发中":
            return "Under development";
          case "样品":
            return "Sample";
          case "样品确认":
            return "Sample confirmation";
          case "已录ERP":
            return "Recorded in erp";

          default:
            break;
        }
      }

      return status;
    },
  },
  async mounted() {
    this.role = getRole();

    await GetProductCatlog().then((res) => {
      this.catlogs = res.data.data;
    });

    if (this.$route.query.catlog > -1) {
      this.searchParam.catlog = this.$route.query.catlog;
      this.SearchFormData.catlog = this.catlogs.find(
        (item) => item.id == this.searchParam.catlog
      ).id;
    }

    if (this.$route.query.catlog == -2) {
      this.searchParam.catlog = -2;
      this.searchParam.model = this.$route.query.value;
    }

    this.refresh(this.currentPage);
  },
};
</script>

<style>
.itemroot {
  border: 2px solid gainsboro;
  padding: 10px 0px;
}

.wrap p{
  margin: 3px 0px;
}
</style>